/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import ReactGA from 'react-ga4';
import { projects } from 'components/constants';

type Props = {
  projectSelected: any;
  setProjectSelected: (project: string) => void;
  content: React.ReactNode;
  category: string;
};

const MenuProjects = ({
  projectSelected,
  setProjectSelected,
  content,
  category,
}: Props) => {
  return (
    <>
      <div className="content">{content}</div>
      <ul className="our-projects">
        {projects
          .sort((a, b) => ('' + a.title).localeCompare(b.title))
          .filter(
            (item) => item.category === category, // && item.value !== 'DingleyPumpStation'
          )
          .map(
            ({ title, value, category, subcategory, color, categoryColor }) => {
              // Use categoryColor if set, otherwise use color
              const effectiveColor = categoryColor || color;
              return (
                <li
                  key={value}
                  className={`${
                    projectSelected.project === value ? 'is-active' : ''
                  } ${category} ${subcategory} color-${effectiveColor}`}
                >
                  <a
                    href="#"
                    rel="nofollow"
                    onClick={(e) => {
                      e.preventDefault();
                      setProjectSelected(value);
                      ReactGA.event({
                        category: `Left Menu - ${category}`,
                        action: 'Map filter/zoom',
                        label: title,
                      });
                    }}
                  >
                    <span className="square-category"></span>
                    {title.includes(' - between') ? (
                      <div style={{ paddingBottom: '7px' }}>
                        <span className="title jump-line">
                          {title.split(' - ')[0]}
                        </span>
                        <span className="subtitle">
                          {title.split(' - ')[1]}
                        </span>
                      </div>
                    ) : (
                      <span className="title">{title}</span>
                    )}
                  </a>
                </li>
              );
            },
          )}
      </ul>
    </>
  );
};

export default MenuProjects;
